import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prestamo-solidario',
  templateUrl: './prestamo-solidario.component.html',
  styleUrls: ['./prestamo-solidario.component.scss']
})
export class PrestamoSolidarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
